import { onboardingQueryKeys as e } from "../onboarding/useOnboardingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { workspacesApi as r } from "@maat/api-main";
//#region src/workspaces/useInviteMutation.ts
var i = (i) => {
	let a = n();
	return t({
		mutationFn: (e) => r.invite(i, e),
		onSuccess: () => {
			a.invalidateQueries({ queryKey: e.status() });
		}
	});
};
//#endregion
export { i as useInviteMutation };
